import React, {lazy, Suspense} from 'react';

import {AppContext} from '../../AppModule/Context';

import SuspenseLoader from '../common/genericComponents/suspenseLoader/suspenseLoader';

import UtilsService from '../../services/utilsService';
import indexDbService from '../../services/indexDbService';

import VIDABOO_CONSTANTS from '../../config/consts';

const ThreedContainer = lazy(() => import('./threedContainer'));

class ThreedWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dbInitialization: false,
    };
  }
  componentDidMount() {
    if (this.props.client) {
      indexDbService.initialize((result) => {
        if (result) {
          this.setState({dbInitialization: true});
        }
      });
    }
    const isPersonalPage = UtilsService.getIsPersonalPage();
    if (isPersonalPage) {
      this.context.setThreedContainerSize(
        VIDABOO_CONSTANTS.ACTIVE_VIDEO_SIZE.MEDIUM,
      );
    }
  }

  render() {
    // This condition is added for client side (if present in db,then fetch from that else download)
    return this.props.client ? (
      this.state.dbInitialization ? (
        <Suspense fallback={<SuspenseLoader />}>
          <ThreedContainer {...this.props} />
        </Suspense>
      ) : (
        <div className={'et-threed-loading'}>Initializing the 3D Engine</div>
      )
    ) : (
      <Suspense fallback={<SuspenseLoader />}>
        <ThreedContainer {...this.props} />
      </Suspense>
    );
  }
}

ThreedWrapper.contextType = AppContext;
export default ThreedWrapper;
